import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c27ee4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("封禁")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("解封")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_vue3VideoPlay = _resolveComponent("vue3VideoPlay")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "直播标题",
          value: _ctx.searches.title,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.title) = $event)),
          style: {"width":"200px"}
        }, null, 8, ["value"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: $setup.onSearch,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          style: {"margin-left":"10px"},
          onClick: $setup.onReset
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          loading: _ctx.loading,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'is_online')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.disable == null ? record.is_online == 1 ? '直播中' :'未直播' :'已封禁'), 1))
              : _createCommentVNode("", true),
            (column.key === 'unblocking_time')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.disable == null ? '状态正常' : record.disable.unblocking_time), 1))
              : _createCommentVNode("", true),
            (column.key === 'cover')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 2,
                  src: record.cover,
                  style: {"width":"40px","height":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.getdetail(record)),
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (record.disable == null )
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        danger: "",
                        type: "primary",
                        style: {"margin":"5px"},
                        onClick: ($event: any) => ($setup.onDIs(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (record.disable !== null )
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        size: "small",
                        type: "primary",
                        style: {"margin":"5px"},
                        onClick: ($event: any) => ($setup.unlock(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visable,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visable) = $event)),
      title: "直播",
      onCancel: $setup.handleOk,
      style: {"max-width":"850px","max-height":"900px","width":"850px","height":"900px"},
      footer: null
    }, {
      default: _withCtx(() => [
        (_ctx.visable)
          ? (_openBlock(), _createBlock(_component_vue3VideoPlay, _mergeProps({ key: 0 }, $setup.options, { poster: "https://cdn.jsdelivr.net/gh/xdlumia/files/video-play/ironMan.jpg" }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onCancel"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.disVisable,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.disVisable) = $event)),
      title: "关闭直播",
      onOk: $setup.closeLive
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "违规原因",
              name: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.reason,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reason) = $event)),
                  placeholder: "请输入违规原因"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "解封时间",
              name: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.unblocking_time,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.unblocking_time) = $event)),
                  "show-time": "",
                  placeholder: "请选择解封时间",
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.unlockVisable,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.unlockVisable) = $event)),
      title: "解封",
      onOk: $setup.unlockLive
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 3 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "备注",
              name: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.reason,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reason) = $event)),
                  placeholder: "请输入备注"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}